{
  "agendasAndModules": {
    "conditions": {
      "list": "List of Conditions",
      "filters": {
        "title": "Filter by form item",
        "actions": "Actions"
      },
      "confirmationDeletionModal": {
        "title": "Do you really want to delete the condition?",
        "description": "By confirming, the condition will be deleted."
      }
    },
    "numberOfSelectedValues": "Number of selected values"
  },
  "modulesAndAgendas": {
    "numberFormatting": {
      "unit": "Unit",
      "separator": {
        "label": "Thousands separator",
        "none": "None",
        "space": "Space",
        "dot": "Dot",
        "comma": "Comma"
      },
      "mathRound": {
        "label": "Mathematical rounding",
        "arithmetic": "Arithmetic",
        "up": "Up",
        "down": "Down"
      },
      "roundTo": {
        "label": "Round to",
        "tenthousandths": "Round to the nearest ten-thousandths",
        "thousandths": "Round to the nearest thousandths",
        "hundredths": "Round to the nearest hundredths",
        "tenths": "Round to the nearest tenths",
        "dozens": "Round to the nearest tens",
        "hundreds": "Round to the nearest hundreds",
        "thousands": "Round to the nearest thousands"
      }
    },
    "sendDataToErp": {
      "modal": "Paired columns",
      "pairingModal": "Paired columns"
    },
    "takeDataFromErp": {
      "modal": "Paired columns",
      "pairingModal": "Paired columns"
    },
    "goToExternalCatalogue": {
      "sendingValuesPairing": "Pair values to send",
      "receivingRecordsPairing": "Records item to receive data",
      "receivingValuesPairing": "Pair values to receive",
      "shoppingCartHeader": "Shopping cart header",
      "shoppingCartItems": "Shopping cart items",
      "additionalPairing": "Additional pairing for cart items",
      "additionalPairingRowTitle": "Map field",
      "additionalPairingTarget": "Cart item field",
      "additionalPairingSource": "Source"
    },
    "purchaseExternalCatalogue": {
      "sendHeaderPairing": "Header pairing for sending",
      "sendItemsPairing": "Items pairing for sending",
      "receiveHeaderPairing": "Header pairing for receiving",
      "receiveItemsPairing": "Items pairing for receiving"
    },
    "buttonAdminTemplate": "Template Admin",
    "actions": {
      "sendDataToErpWithItems": {
        "headerPairing": "Header field mapping",
        "recordsFormItem": "Records-type FormItem (items)",
        "itemsTemplate": "Items Helios template",
        "itemsAgenda": "Items agenda",
        "itemsPairing": "Items field mapping"
      },
      "addRow": "Add record",
      "addRecipient": "Add Recipient",
      "addressees": "Addressees",
      "append": "Append",
      "createRow": "New record",
      "directValue": "Direct Value",
      "delete": "Delete",
      "changeStrategy": "Method of editing",
      "notificationSetup": "Notification setup",
      "moveAction": "Move action",
      "replace": "Replace",
      "requiredAction": "Notification requiring action",
      "selectedValue": "Selected Value",
      "target": "Target",
      "source": "Source",
      "selectTablesColumn": "Select table column",
      "selectRecordsColumn": "Select referenced record column",
      "selectUsersColumn": "Select user attribute",
      "draft": "Draft",
      "toSend": "To Send",
      "isNotEditable": "Not editable",
      "mustBeIsKey": "The column must be marked as a key",
      "arrayValuesFormItem": "Value field for dynamic relation",

      "step": {
        "executeActionsForChangedRecord": "Execute actions for changed record",
        "executeActionsForCreatedRecord": "Execute actions for created record",
        "1": {
          "_": "Select another record",
          "chooseFromForm": "Select item from form",
          "chooseFromTemplate": "Select column from template",
          "catalogueValue": "Catalogue value",
          "modules": "Modules",
          "agendas": "Agendas",
          "views": "Views",
          "modalTitle": "Link to another record",
          "noItems": "No items",
          "apiTable": "API Table",
          "redirectToLastCreatedRecord": "Redirect to last created record"
        },
        "2": {
          "selectFilter": "Select filter",
          "selectPairing": "Select pairing",
          "selectTargetAgenda": "Select target agenda",
          "selectTargetRecords": "Select target Records",
          "externalFunction": "External function"
        },
        "3": {
          "selectInputs": "Select inputs",
          "selectOutputs": "Select outputs",
          "selectParameter": "Select parameter"
        },
        "linkToRecord": {
          "modalTitle": "Select a value"
        }
      },
      "unselectedValue": {
        "error": "You must select all required values"
      },
      "typeMismatch": {
        "error": "Types do not match"
      },
      "requiredItems": {
        "error": "You must add at least one item"
      },
      "arrayValuesFormItemRequired": {
        "error": "You must select the source field for related record values"
      }
    },
    "change": {
      "modal": "Values for changing a record"
    },
    "condition": {
      "action": "Action",
      "add": "Add",
      "applyToAll": "Apply to all section attributes",
      "comparison": "Comparison",
      "comparisonIsBiggerByTooltip": "Is greater or equal (source +/- value)",
      "comparisonIsSmallerByTooltip": "Is smaller or equal (source +/- value)",
      "comparisonIsBiggerTooltip": "Is greater than source or value",
      "comparisonIsSmallerTooltip": "Is smaller than source or value",
      "currentState": "Current State",
      "function": "Function",
      "overwrite": "Overwrite",
      "previousState": "Previous State",
      "repeat": "Repeat",
      "sectionName": "Section Name",
      "conditionName": "Condition Set Name",
      "conditionDescription": "Condition Set Description",
      "sectionDescription": "Section Description",
      "source": "Source",
      "success": {
        "add": "Condition was successfully added",
        "deleted": "Condition was successfully deleted",
        "reordered": "Order successfully changed",
        "stateChanged": "State successfully changed",
        "updated": "Condition was successfully updated"
      },
      "errors": {
        "conditions": "You must select at least one condition",
        "actions": "You must select at least one action",
        "missingConditionsError": "You must select at least one condition",
        "notCompleteError": "Condition is not complete"
      },
      "state": {
        "_": "State",
        "logicalOperator": "Logical Operator",
        "editable": "Editable",
        "hidden": "Hidden",
        "visible": "Visible"
      },
      "template": "Template",
      "value": "Value",
      "sourceAndValue": "Source and Value",
      "sourcePlusMinusValue": "Source +/- Value",
      "sourceOrValue": "Source or Value",
      "whichValue": "which value",
      "addGroup": "Add Group",
      "addCondition": "Add Condition",
      "addGroupInside": "Add Group Inside",
      "addConditionInside": "Add Condition Inside"
    },
    "conditionsSection": "New conditions",
    "create": {
      "modal": "Values for creating a new record"
    },
    "CreatedDate": "Created Date",
    "CurrentUser": "Current User",
    "DateNow": "Date and Time",
    "distinctForEach": {
      "modal": "Values for creating a new record"
    },
    "createForEach": {
      "modal": "Values for creating a new record"
    },
    "dialog": {
      "behavior": {
        "label": "Behavior",
        "DiscardAndSave": "Discard and save",
        "KeepAndSave": "Keep and save",
        "Keep": "Keep"
      },
      "formItems": "Form items"
    },
    "form": {
      "checked": "Checked",
      "clear": "Clear the section",
      "clearContent": "Do you really want to clear the content of the section?",
      "confirmAction": "Confirm action",
      "runAction": "Run",
      "RunActionsWithoutSaving": "Run action without saving.",
      "SaveButDoNotRunActions": "Save but do not run actions.",
      "NotifyUserToSave": "Are you sure you want to run this action?",
      "delete": "Delete section",
      "deleteItem": "Delete section item",
      "deleteContent": "Are you sure you want to delete the entire section, including all its items? If any item has dependencies, the deletion will not proceed. These dependencies must first be resolved separately.",
      "deleteSectionConflict": "Some items in this section are used elsewhere in the system. Resolve their dependencies for the affected items, then try deleting the section again.",
      "deleteItemContent": "Are you sure you want to delete the section item?",
      "deleteItemFlow": {
        "blockingDependencies": "Where this item is used",
        "cleanupTitle": "Related settings will also be deleted",
        "blockedTitle": "This form item cannot be deleted",
        "blockedDescription": "Remove all blocking dependencies before deleting this form item.",
        "cleanupDescription": "The sections, visibility rules, and delete-notification actions listed below will be deleted along with this form item. Each section is deleted in full, even if only one rule or action uses this item.",
        "deleteWithDependencies": "Delete item and related settings",
        "dependencyCount": "Dependencies: {{count}}",
        "viewDetails": "View details",
        "affectedSections": "Sections to delete",
        "regularSection": "Condition section",
        "recurrentSection": "Bulk-change section",
        "globalVisibilityCleanup": "Visibility rules to delete",
        "deleteNotificationsCleanup": "Delete-notification actions to delete",
        "deleteNotificationAction": "Action {{actionId}}",
        "deleteNotificationOwnerSection": "Owner section: {{sectionId}}",
        "preflightFailed": "We couldn’t check where this item is used. Try again before deleting it.",
        "dependenciesChanged": "The dependencies changed after this dialog was opened. Review the refreshed details before trying again.",
        "deleteFailed": "The form item could not be deleted.",
        "blockers": {
          "OtherAgendaCondition": "Conditions in other agendas",
          "ForeignFieldVisibility": "Visibility conditions on other form items",
          "ViewUsage": "View usage",
          "RecordData": "Populated record attributes",
          "FormItemDefinition": "References from other form-item definitions",
          "FormItemDefaultValue": "References from form-item default values"
        }
      },
      "formButtons": "Selecting form elements",
      "globalSettings": "Global settings",
      "globalSettingsSuccess": "Global settings were successfully saved",
      "item": {
        "dependencies": {
          "label": "Dependencies",
          "conditions": "Conditions",
          "bulkChanges": "Bulk Changes",
          "otherAgendas": "Other agendas",
          "noOtherAgendas": "No dependencies in other agendas",
          "noVisibilityConditions": "No visibility conditions",
          "loadFailed": "Could not load dependencies",
          "module": "Module",
          "matchingSections": "Matching sections: {{count}}",
          "matchedZones": "Matching areas",
          "matchedActions": "Matching actions",
          "states": {
            "active": "Active",
            "disabled": "Disabled"
          },
          "noSections": "No matching sections",
          "ownerFormItem": "Form item",
          "visibilitySection": "Visibility section",
          "referencedFormItem": "References the selected form item",
          "visibilityConditions": "Visibility conditions",
          "globalConditions": "Global conditions"
        },
        "columnSettings": {
          "invalidConfiguration": "Check column widths for the following items: {{items}}. Fixed width must be a positive integer and relative width must be selected.",
          "title": "Column width in table view",
          "widthMode": "Column width",
          "modes": {
            "auto": "Automatic",
            "fixed": "Fixed value",
            "relative": "Wider/Narrower"
          },
          "fixedWidth": "Width",
          "positiveInteger": "Enter a positive integer.",
          "preset": "Width preset",
          "presets": {
            "normal": "Normal",
            "wider": "Wider",
            "widest": "Widest"
          },
          "overflow": "Content overflow",
          "overflowModes": {
            "ellipsis": "Ellipsis + tooltip",
            "wrap": "Wrap"
          },
          "preview": "Preview",
          "previewText": "Example of longer table cell content",
          "help": "Choose how this field appears as a column in table view.",
          "modeHelp": {
            "auto": "Let the table determine the column width.",
            "fixed": "Set an exact column width in pixels.",
            "relative": "Choose one of three predefined column widths."
          },
          "fixedHelp": "Pixels (px). Enter a whole number greater than 0.",
          "invalidWidth": "Enter a valid width",
          "overflowHelp": {
            "ellipsis": "Keep text on one line. Hover over or focus the cell to read the full value.",
            "wrap": "Show the full value on multiple lines. Rows grow to fit the text."
          },
          "previewColumn": "Field value",
          "previewHelp": "Illustrative preview. Large widths are limited to the space available here."
        },
        "columnSelection": "Column selection",
        "multiColumnSelection": "Multi-column selection",
        "columnToShow": "Column to show",
        "collapse": "Load section as collapsed",
        "view": "View",
        "viewMode": {
          "label": "View mode",
          "dialog": "Dialog",
          "nestedListing": "Nested Listing",
          "portal": "Portal"
        },
        "button": {
          "label": "Button Name",
          "placeholder": "Name the button",
          "showButtonDirectly": "Show directly on line"
        },
        "comment": {
          "add": "Add comment",
          "edit": "Edit comment",
          "text": "comments"
        },
        "computed": {
          "_": "Computed text",
          "add": "Add next",
          "operation": "Operation",
          "operationType": {
            "add": "Add",
            "average": "Average",
            "chain": "Concatenate",
            "divide": "Divide",
            "max": "Maximum",
            "min": "Minimum",
            "multiply": "Multiply",
            "subtract": "Subtract"
          },
          "prefix": "Field to fill",
          "value": "Select value",
          "referencedFormItemId": "Operation column",
          "errors": {
            "empty": "You must select a value",
            "noJoinTypes": "Error: cannot load operation types"
          }
        },
        "date": {
          "from": "Select value from",
          "settings": "Settings",
          "to": "Select a value to",
          "value": "Hodnota"
        },
        "fileUpload": {
          "add": "Upload document",
          "text": "Click to select a document or drag and drop here"
        },
        "placeholder": {
          "one": "Drag and drop the required elements to create the form.",
          "two": "Use the + button to add another column."
        },
        "records": {
          "_": "Link to another record",
          "external": "Link to external record",
          "interactionOptions": {
            "label": "Interaction Options",
            "creation": "Creating new records",
            "editing": "Editing existing records",
            "addition": "Adding existing records"
          },
          "nestedListing": {
            "addRowError": "Error adding new record",
            "addRowSuccess": "Saved",
            "deletion": "Delete records",
            "deleteSuccess": "Records were successfully deleted",
            "deleteError": "Error deleting records"
          },
          "updateRowsSuccess": "Saved",
          "updateRowsError": "Error updating records",
          "conflictingRowValues": "This record has different values on different rows. Make them match and save again.",
          "unsavedJoinedChanges": "Some changes could not be saved.",
          "calculate": {
            "fieldRequired": "This field is required for calculation",
            "fillAllRequiredFields": "Please fill all required fields before calculation"
          },
          "editableWithRecordDetail": "Edit together with detail"
        },
        "tables": {
          "_": "Selection from tables",
          "title": "Tables"
        },
        "user": {
          "_": "User selection",
          "roleSelect": "Role selection",
          "userSettingsSelect": "User Settings Selection"
        },
        "editSection": "Edit Section",
        "newSection": "New Section",
        "record": {
          "directValue": "Value",
          "paramsFilledError": "You must fill in all parameters"
        },
        "recordExternal": {
          "flowItem": "Selection of flow item from the form",
          "heliosItem": "Selection of item from Helios template"
        },
        "renameSection": "Rename Section"
      },
      "saveSuccess": "Data saved successfully",
      "table": {
        "title": "Table Setup"
      },
      "warning": {
        "addInVisibility": "The applied settings will be added to all existing settings on individual elements within the section.",
        "emptySection": "No items are set in the form",
        "changeInVisibility": "The applied settings will replace all existing settings on individual elements within the section.",
        "sectionNameExists": "This section name already exists",
        "moveSubTabLayoutChange": "The destination section has fewer columns or rows. All subsection tabs in that section will change layout. Do you want to continue?"
      }
    },
    "formSection": {
      "hasActionInputs": "Attributes editable in detail",
      "conditions": "Conditions",
      "columnBorderColor": "Column border color",
      "attributeColor": "Attribute color",
      "attributeTextColor": "Text color",
      "iconColor": "Icon color",
      "textStyleBold": "Bold text",
      "textStyleItalic": "Cursive",
      "textStyleUnderlined": "Underline text",
      "labelLayout": "Label layout",
      "labelLayoutSideBySide": "Side by side",
      "labelLayoutStacked": "Stacked",
      "labelAlign": "Label align",
      "valueAlign": "Value align",
      "align": {
        "left": "Left",
        "center": "Center",
        "right": "Right"
      },
      "enableConditions": "Enable Conditions"
    },
    "importAgenda": {
      "_": "Import agenda",
      "exported": "Exported agenda",
      "newVersion": "Import new version agenda",
      "invalidJSON": "Invalid JSON file format",
      "emptySelectError": "Both options must be selected"
    },
    "linkToDifferentRecordStepModal": "Link to a different record",
    "maxFilesNumber": "Maximum number of files",
    "MobileAccess": "Mobile Access",
    "new": "New agenda",
    "rolesSection": "Roles",
    "SelectAllFromView": "Select All",
    "settingsSection": "Data for agenda",
    "UpdatedDate": "Updated Date",
    "UserEmail": "User Email",
    "UserContactEmail": "User Contact Email",
    "UserReference": "User Reference",
    "UserId": "User ID",
    "RealUserId": "Actual user ID",
    "UserRole": "User Role",
    "noticeOnSaving": {
      "title": "Save Notice",
      "none": "No notice",
      "pointOut": "Just point out",
      "forcedSave": "Forced save",
      "calculate": "Recalculate values",
      "runActionsWithoutSaving": "Run actions without saving",
      "saveButDoNotRunActions": "Save but do not run actions"
    },
    "confirmationModalBeforeNavigation": {
      "title": "Do you really want to leave this page?",
      "description": "By confirming, all unsaved changes will be saved."
    },
    "settings": {
      "hideInOverviews": "Hide in agenda overviews",
      "previewView": "View for module record preview",
      "previewViewNone": "Do not show records",
      "previewViewHelper": "In the module preview, users will only see records returned to them by this view — it must be assigned to their role.",
      "status": "Status",
      "statusSelect": "Select Status",
      "statuses": {
        "active": "Active",
        "draft": "Draft",
        "archived": "Archived"
      }
    },
    "EmptyValue": "Empty Value",
    "RecordId": "Record ID",
    "ParentRecordId": "Parent Record ID",
    "records": {
      "of": "of",
      "records": "records"
    },
    "None": "None",
    "Body": "Body",
    "Header": "Header",
    "Status": "Status",
    "Error": "Error"
  },
  "tables": {
    "deleteConfirmation": "Are you sure you want to delete the selected tables? This action cannot be undone.",
    "deleteViewConfirmation": "Are you sure you want to delete the selected views? This action cannot be undone.",
    "modalAddtable": {
      "addColumn": "Add Column",
      "columnName": "Column Name",
      "editColumn": "Edit Column",
      "error": {
        "missingColumns": "Table must have at least one column",
        "uniqueName": "Table name must be unique",
        "uniqueRequired": "At least one column must be marked as unique",
        "invalidColumnType": "Table contains incorrect column type",
        "invalidMappingKey": "Table contains invalid REST API column mapping"
      },
      "tableName": "Table Name",
      "sourceType": "Source Type",
      "sourceTypeModal": {
        "title": "Select source type",
        "sort": {
          "label": "Source type sorting",
          "asc": "A to Z",
          "desc": "Z to A"
        }
      },
      "tableNamePlaceholder": "Enter Table Name",
      "title": {
        "_": "Add Table",
        "create": "Add Table",
        "edit": "Edit Table"
      },
      "unique": "Column is unique"
    },
    "successfully": {
      "created": "Tables were successfully created",
      "deleted": "Tables were successfully deleted",
      "updated": "Tables were successfully updated"
    }
  },
  "actions": {
    "actionsTypes": {
      "Archive": "Archive",
      "Change": "Change",
      "Create": "Create",
      "Dialog": "Dialog",
      "Delete": "Delete",
      "DeleteNotification": "Delete Notification",
      "IncreaseVersion": "Increase Version",
      "Notify": "Notify",
      "DistinctForeach": "Unique for all",
      "CreateForEach": "Create for all",
      "SendDataToErp": "Send data to ERP",
      "TakeDataFromErp": "Load data from ERP",
      "ExternalAction": "External action",
      "ExternalRestApi": "External Rest Api",
      "GoToExternalCatalogue": "Go to external catalogue",
      "PurchaseExternalCatalogue": "Send order to external catalogue",
      "SendDataToErpWithItems": "Send data to ERP with items",
      "Redirect": "Redirect",
      "Halt": "Halt"
    },
    "notificationValue": "Notification value"
  },
  "agendas": {
    "modules": {
      "select": "Select Module"
    }
  },
  "importAgendas": {
    "deleteConfirmation": "Are you sure you want to delete the selected imports? This action cannot be undone."
  },
  "massChange": {
    "launch": "Launch",
    "succesfullyExecuted": "Succefully executed"
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Add parameter",
      "email": "Email notification",
      "insertParam": "Insert parameter",
      "name": "The name of the notification",
      "fallbackAdmins": "Notification admin",
      "fallbackAdminsTooltip": "Manages notifications and receives notifications about which inactive user failed to receive notifications – these notifications are forwarded to the Notification admin",
      "fallbackAdminsEmpty": "No available admins",
      "fallbackAdminsError": "Failed to load admins",
      "inactiveUser": "Inactive user",
      "nameRequired": "Notification name is required",
      "parameter": "The name of the parameter",
      "parameterExists": "This parameter already exists",
      "parameterRequired": "Parameter name is required to fill in",
      "push": "Push notifications",
      "subject": "Subject",
      "subjectRequired": "Subject is required",
      "text": "Notification text",
      "web": "Notifications in the app",
      "description": "Description",
      "bodyRequired": "Body is required",
      "notificationRequired": "You must select at least one type of notification",
      "channels": "Channels"
    },
    "confirmationModalForLeaving": {
      "title": "Are you sure you want to leave this page?",
      "description": "By clicking confirm, you will leave the page and lose any unsaved data."
    },
    "confirmationModalForRemoving": {
      "title": "Are you sure you want to delete this notification template?",
      "description": "By clicking confirm, the template will be deleted."
    },
    "title": {
      "listOfTemplates": "Notification templates",
      "detailTitle": "Notification template",
      "usedByTemplates": "Used in Helios templates"
    }
  },
  "recurrence": {
    "label": "Recurrence",
    "daily": "Daily",
    "hourly": "Hourly",
    "monthly": "Monthly",
    "never": "Never",
    "weekly": "Weekly",
    "yearly": "Yearly"
  },
  "recurrenceType": {
    "label": "Recurrence Type",
    "patternonly": "Pattern Only",
    "timeranged": "Time Ranged",
    "timespecific": "Time Specific"
  },
  "executeFrom": "Execute From",
  "executeTill": "Execute Till",

  "restApiConnections": {
    "action": {
      "arrayBehavior": {
        "label": "Array Transformation Type",
        "TakeFirst": "Take First",
        "TakeLast": "Take Last",
        "JoinAll": "Join All",
        "UseAll": "Use All",
        "FollowLink": "Follow Link",
        "DirectContent": "Direct Content"
      },
      "inputs": {
        "headers": "Call Headers",
        "label": "Rest Api Call",
        "parameters": "Call Parameters",
        "parameterName": "Parameter Name"
      },
      "arrayJsonPath": "Array JSON Path",
      "outputs": {
        "arrayJsonPathEmptyHint": "Leave empty to map one response. Set a JSON path to an array to match and upsert one record per item.",
        "arrayJsonPathUpsertHint": "Each array item is matched and upserted. Key outputs identify the existing record.",
        "fileName": "File name (optional)",
        "isKey": "Is key",
        "isKeyHint": "Matches the existing record for each array item.",
        "key": "Key",
        "keyMustUseBody": "Key outputs can only use Body.",
        "label": "Output Transformation",
        "sourceIgnoredInUpsert": "This source is not used in array upsert mode. Choose Body or Header.",
        "upsertRequiresKey": "Mark at least one output as a key. Array upsert writes nothing without one.",
        "upsertRequiresTargetAgenda": "Select another record in the previous step. Array upsert writes nothing without a target agenda."
      },
      "migrationWarning": "This template was created before connections were introduced. Please re-select the connection to continue.",
      "transformationType": {
        "label": "Value Transformation Type",
        "None": "None",
        "Text": "Text",
        "Number": "Number",
        "Bool": "Boolean",
        "Date": "Date"
      }
    },
    "form": {
      "authType": "Authentication type",
      "authTypes": {
        "None": "None",
        "BasicAuth": "Basic auth",
        "TokenAuth": "Token auth",
        "ApiKey": "API key",
        "OAuth2": "OAuth 2.0"
      },
      "baseUrl": "Base url",
      "basicAuthUsername": "Basic auth username",
      "basicAuthPassword": "Basic auth password",
      "basicAuthPasswordPlaceholder": "Leave blank to keep existing",
      "timeZone": "Time zone",
      "timeZoneHint": "Time zone in which this API sends dates without an offset (e.g. 2026-12-14T07:00:00). Leave empty if it sends UTC or full offsets.",
      "tokenAuthLoginRequest": "Login request",
      "tokenAuthRefreshRequest": "Refresh request",
      "tokenAuthTokenExtraction": "Token extraction",
      "tokenAuthUsername": "Token auth username",
      "tokenAuthPassword": "Token auth password",
      "tokenAuthPasswordPlaceholder": "Leave blank to keep existing",
      "tokenAuthLoginHttpMethod": "Login HTTP method",
      "tokenAuthLoginRelativeUri": "Login relative URI",
      "tokenAuthLoginBodyTemplate": "Login body template",
      "tokenAuthRefreshHttpMethod": "Refresh HTTP method",
      "tokenAuthRefreshRelativeUri": "Refresh relative URI",
      "tokenAuthRefreshBodyTemplate": "Refresh body template",
      "tokenAuthTokenPath": "Token path",
      "tokenAuthRefreshTokenPath": "Refresh token path",
      "tokenAuthTokenTtlMinutes": "Token TTL (minutes)",
      "tokenAuthRefreshTokenTtlMinutes": "Refresh token TTL (minutes)",
      "name": "Connection name",
      "title": "Rest api connection"
    },
    "list": "List of rest api connections",
    "remove": {
      "title": "Do you really want to delete the rest api connection?",
      "text": "By confirming, the rest api connection will be deleted."
    },
    "test": {
      "warning": {
        "title": "Form changes detected",
        "description": "The form contains unsaved values. Please save the form before running the test."
      }
    },
    "template": {
      "list": "List of rest api templates",
      "remove": {
        "title": "Do you really want to delete the rest api template?",
        "text": "By confirming, the rest api template will be deleted."
      },
      "form": {
        "body": "Request body",
        "headers": {
          "add": "Add header",
          "name": "Name",
          "value": "Value"
        },
        "httpMethod": "HTTP request methods",
        "logLevel": "Log level",
        "name": "The name of the rest api",
        "parameterUsageError": "Each defined parameter must be used (e.g., $parameter) in the Relative URI, Body, or in a header value.",
        "relativeUri": "Relative uri",
        "title": "Rest api template"
      },
      "test": {
        "label": "Test",
        "response": "Response",
        "run": "Run Test"
      }
    }
  },
  "roles": {
    "approvalPermission": "Approval",
    "archivePermission": "Archiving",
    "commentPermission": "Commenting",
    "createPermission": "Record Creation",
    "deletePermission": "Deletion",
    "readPermission": "Reading",
    "title": "Flow"
  },
  "rows": {
    "deleteConfirmation": "Are you sure you want to delete the selected rows? This action cannot be undone.",
    "successfully": {
      "added": "Rows were successfully added",
      "deleted": "Rows were successfully deleted",
      "updated": "Rows were successfully updated"
    }
  },
  "export": {
    "error": "Something went wrong.",
    "sentSuccessfully": "Export request sent. The link to the generated file will come via notification.",
    "toPdf": "Export to PDF",
    "toCsv": "Export to CSV",
    "toZipWithAttachments": "Export with attachments",
    "toZipWithAttachmentsAndItems": "Export with attachments and items",
    "allToCsv": "Export all to CSV",
    "toXlsx": "Export to XLSX",
    "title": "Export"
  },
  "view": {
    "recordsDisplayColumn": "Record display column",
    "saveBeforePreview": "This view has unsaved changes. Save the view before opening the preview.",
    "sortBy": "Sort by",
    "desc": "descending",
    "typeSelect": "View Type",
    "actionForm": "Form View",
    "standard": "Standard View",
    "calendar": "Calendar View",
    "calendarSettings": {
      "formItems": {
        "allDay": "All day",
        "category": "Category",
        "endDate": "End date",
        "startDate": "Start date",
        "title": "Title"
      },
      "label": "Calendar settings"
    },
    "catalogue": "Catalogue View",
    "userSettings": "User Settings",
    "shoppingCart": "Shopping Cart",
    "shoppingCartSettings": "Shopping Cart Settings",
    "cartDescription": "Cart Description",
    "cartItems": "Number of Items in Cart",
    "cartTotal": "Cart Total",
    "cartUser": "Cart User (Current User Filter)",
    "submitFormItems": "Submit Form Items",
    "emptyCart": "Your cart is empty",
    "items": "items",
    "errors": {
      "submitFormItemsRequired": "At least one submit form item is required for shopping cart views"
    },
    "showNestedListColumns": "Show nested list columns",
    "doNotDisplay": "Do not display",
    "displayInFilter": "Display in filter",
    "displayAlways": "Display always",
    "displayInParentWhenFiltering": "Display in parent agenda view",
    "showOnlyExistingValues": "Show only existing values in the filter",
    "showInToolbar": "Show in toolbar"
  },
  "conditionLogs": {
    "search": "Search logs",
    "subtab": {
      "forEach": "Batch actions",
      "erp": "ERP actions"
    },
    "filter": {
      "status": "Status",
      "success": "Success",
      "failed": "Failed",
      "recordId": "Record ID",
      "forEachRecordId": "ForEach record ID",
      "conditionActionId": "Condition action ID",
      "conditionSectionId": "Condition section ID",
      "dateFrom": "Date from",
      "dateTo": "Date to"
    },
    "table": {
      "conditionSectionName": "Condition section name",
      "actionType": "Action type",
      "started": "Started",
      "finished": "Finished",
      "isSuccess": "Status",
      "message": "Message",
      "stackTrace": "Stack trace"
    },
    "detailModal": {
      "title": "Log detail",
      "message": "Message",
      "stackTrace": "Stack trace"
    }
  },
  "conditionErpLogs": {
    "tab": "ERP Logs",
    "search": "Search ERP logs",
    "filter": {
      "wasCreated": "ERP action",
      "created": "Created",
      "updated": "Updated",
      "templateId": "Template ID",
      "recordId": "Record ID",
      "conditionSectionId": "Condition section ID",
      "conditionActionId": "Condition action ID",
      "moduleId": "Module ID",
      "dateFrom": "Date from",
      "dateTo": "Date to"
    },
    "table": {
      "templateId": "ERP template ID",
      "erpKey": "ERP record ID",
      "wasCreated": "Action"
    }
  },
  "warning": {
    "multipleUiDefinitions": "Conditions for displaying elements are overlapping.",
    "multipleUiDefinitionsWithNames": "Conditions for displaying elements are overlapping.\n\nElements with overlapping conditions:\n"
  }
}
